<div class="content">
  <i (click)="onCloseModal()" (keypress)="onCloseModal()" class="icon-cerrar"></i>
  <i class="icon-check"></i>
  <span class="title">{{ successMessage }}</span>
  <!--<p class="info">{{ 'successModal.info' | transloco }}</p>-->
  <sl-button class="button" (clicked)="onCloseModal()" [label]="'successModal.button' | transloco" [type]="'primary'"></sl-button>
</div>
